import { createSlice } from '@reduxjs/toolkit';

import { logger } from '@core/utils';

/**
 * Load selected project from localStorage
 */
export const loadProjectFromStorage = (user) => {
  try {
    const data = localStorage.getItem('currentProject');
    if (data) {
      const stored = JSON.parse(data);
      // Project selection is tenant-sensitive. Never restore legacy/unscoped
      // data, or a selection that belongs to a different authenticated user.
      if (user?.uuid && user?.active_organization && stored?.userUuid === user.uuid && stored?.organizationUuid === user.active_organization && stored?.project) {
        return stored.project;
      }
      localStorage.removeItem('currentProject');
    }
  } catch (error) {
    logger.error('Error loading project from localStorage:', error);
  }
  return null;
};

const initialState = {
  currentProject: null,
};

/**
 * Projects slice for managing project selection state
 */
const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    initializeProject: (state, action) => {
      state.currentProject = loadProjectFromStorage(action.payload);
    },
    setCurrentProject: (state, action) => {
      state.currentProject = action.payload;
    },
    clearCurrentProject: (state) => {
      state.currentProject = null;
    },
  },
});

export const { initializeProject, setCurrentProject, clearCurrentProject } = projectsSlice.actions;

export default projectsSlice.reducer;

// Selectors
export const selectCurrentProject = (state) => state.projects.currentProject;
